<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Nombre</th>
				<th :class="StyleTh">Tipo</th>
                <th :class="StyleTh">Stock Actual</th>
                <th :class="StyleTh">Stock de Salida</th>
                <th :class="StyleTh">Incidencias</th>
            </template>
            <template slot="body">
                <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><p :class="StyleTd">{{lista.NombreElemento}}</p></td>
                    <td><p :class="StyleTd">{{lista.TipoElemento}}</p></td>
                    <td><p :class="StyleTd">{{lista.StockActual}}</p></td>
                    <td><p :class="StyleTd">{{lista.StockDeSalida}}</p></td>
                    <td><p :class="StyleTd">{{lista.Incidencias}}</p></td>
                </tr>
            </template>
        </CList>
    </div>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionInventarioDetalle';
export default {
    name: 'ListaInventarioDetalle',
    props:['pObjEnviado'],
    data() {
        return {
            ConfigList:{
                Title: 'Desgloce de inventario',
                IsModal: false,
                ShowLoader: true,
                BtnReturnShow: true,
                EmitSeccion: EmitEjecuta,
                TitleFirst: 'Inventarios',
                BtnNewShow:false
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 10,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            ListaHeader: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ObjInventario: {},
        }
    },
    methods: {
        async Lista(){
            this.ConfigList.ShowLoader = true;
            this.$http.get("inventarioDesgloce",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdInventario:this.ObjInventario.IdInventario
                }
            }).then((res)=>{
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                // this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            })
        },
        Regresar(){
            this.$router.push({name:'inventario',params:{}});
        },
    },
    created() {
        if(this.pObjEnviado != undefined){
            sessionStorage.setItem('objInventario',JSON.stringify(this.pObjEnviado));
        }
        this.ObjInventario = JSON.parse(sessionStorage.getItem('objInventario'));
        this.bus.$off('EmitReturn');
    },
    mounted() {
        this.Lista();
        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>

<style>

</style>